// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Vendor extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get displayName() {
        return `${this.vendorUnixKey} -- ${this.companyName}`;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  accountNumber?: string;
  address1?: string;
  address2?: string;
  address3?: string;
  city?: string;
  companyName?: string;
  contactName?: string;
  country?: string;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  email?: string;
  fax?: string;
  idNumber?: string;
  internalNotes?: string;
  netDueDays?: number;
  notes?: string;
  phone?: string;
  quickBooksId?: string;
  quickBooksLastExport?: Date;
  remitAddress1?: string;
  remitAddress2?: string;
  remitAddress3?: string;
  remitCity?: string;
  remitEmail?: string;
  remitFax?: string;
  remitPhone?: string;
  remitState?: string;
  remitZip?: string;
  state?: string;
  terms?: string;
  termsDays?: number;
  vendorUnixKey?: string;
  zip?: string;
}

